export const BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const CHAT_SERVICE_URL = import.meta.env.VITE_CHAT_SERVICE_URL;
export const WEBSOCKET_URL = import.meta.env.VITE_WEBSOCKET_URL;
export const WEB_SCRAPING_SERVICE_URL = import.meta.env.VITE_WEB_SCRAPING_SERVICE_URL;
// export const WEBSOCKET_URL = import.meta.env.VITE_WEBSOCKET_URL;

export const getDomainUrlFromStorage = () => {
    try {
        const authData = JSON.parse(window.localStorage.getItem('auth-storage') || '{}');
        const url = authData?.state?.user?.domainUrl;
        if (url) {
            return url.startsWith('http') ? url : `https://${url}`;
        }
    } catch {
        // ignore
    }
    return "";
};

export const getChatServiceUrl = () => `${getDomainUrlFromStorage()}/chat`;
export const getReportingServiceUrl = () => `${getDomainUrlFromStorage()}`;

export const AUTHENTICATE = "/user/api/authenticate";
export const GET_ORGANIZATIONS = "/organizations";

const ENDPOINTS = {
    get HTTP() {
        return {
            LOGIN: `${BASE_URL}/api/authenticate`,
            ORGANIZATIONS: `${BASE_URL}/api/organizations`,
            DOMAIN: `${BASE_URL}/api/domains`,
            ROLES: `${BASE_URL}/user/user-management/roles`,
            USERS: `${BASE_URL}/api/admin/users`,
            DISPOSITIONS: `${getChatServiceUrl()}/agent/disposition/list`,
            END_CHAT: `${getChatServiceUrl()}/agent/add/disposition/details`,
            AGENT_STATUS_LIST: `${getChatServiceUrl()}/agent/status/list`,
            AGENT_STATUS_UPDATE: `${getChatServiceUrl()}/agent/update/user-status`,
            AGENT_CHAT_HISTORY: `${getChatServiceUrl()}/agent/chat/history`,
            AGENT_CHAT_BY_CHATID: `${getChatServiceUrl()}/agent/chat/history/by-chatid`,
            CHANGE_PASSWORD: `${BASE_URL}/user/api/account/change-password`,
            QUEUE_LIST: `${getChatServiceUrl()}/agent/queue/chat/list`,
            LOGOUT: `${BASE_URL}/user/api/logout`,
            CONVERSATION_USERS_ANALYTICS: `${getReportingServiceUrl()}/reporting/conversation/user/analytics`,
            AGENT_TABLE_ANALYTICS: `${getReportingServiceUrl()}/reporting/live/agent/analyticsGraph`,
            CONVERSATION_USERS_REPORT_DOWNLOAD: `${getReportingServiceUrl()}/reporting/conversation/user/report/download`,
            CONVERSATION_USER_CHAT_IDS: `${getReportingServiceUrl()}/reporting/conversation/user/chatIDs`,
            CONVERSATION_USER_CONVERSATION_ID: `${getReportingServiceUrl()}/reporting/conversation/user/conversationIDs`,
            MODULE_SERVICE_ANALYTICS: `${getReportingServiceUrl()}/reporting/module/service/analytics`,
            FEEDBACK_SERVICE_ANALYTICS: `${getReportingServiceUrl()}/reporting/feedback/analytics`,
            FEEDBACK_SENTIMENT_REPORT: `${getReportingServiceUrl()}/reporting/feedback/sentiment/analytics`,
            FEEDBACK_SENTIMENT_REPORT_DOWNLOAD: `${getReportingServiceUrl()}/reporting/feedback/sentiment/report/download`,
            PEAK_USAGE_ANALYTICS: `${getReportingServiceUrl()}/reporting/peak/usage/analytics`,
            SENTIMENTAL_ANALYTICS_REPORT: `${getReportingServiceUrl()}/reporting/conversation/sentiment/analytics`,
            GET_ANALYTICS_REPORT_HISTORY: `${getReportingServiceUrl()}/reporting/chat/history`,
            GET_STATUS_HISTORY: `${getReportingServiceUrl()}/reporting/disposition/categories`,
            OVERALL_SENTIMENT_ANALYTICS_REPORT: `${getReportingServiceUrl()}/reporting/sentiment/analytics`,
            BOT_PERFORMANCE_ANALYTICS: `${getReportingServiceUrl()}/reporting/bot/performance/analytics`,
            SENTIMENT_REPORT_DOWNLOAD: `${getReportingServiceUrl()}/reporting/conversation/sentiment/report/download`,
            LIVE_AGENT_ANALYTICS: `${getReportingServiceUrl()}/reporting/live/agent/analytics`,
            AGETN_STATUS_COUNT: `${getChatServiceUrl()}/supervisor/agent/count-by-status`,
            AGENT_LIST: `${getChatServiceUrl()}/supervisor/agent/list`,
            SUPERVISOR_CHAT_COUNT: `${BASE_URL}/user/supervisor/chat-count`,
            SUPERVISOR_QUEUE_LIST: `${BASE_URL}/user/supervisor/queue-list`,
            SUPERVISOR_MAPPED_QUEUE_DETAILS: `${BASE_URL}/user/supervisor/mapped-queue-details`,
            SUPERVISOR_LIVE_CHATS: `${getChatServiceUrl()}/supervisor/live/chats`,
            ADMIN_QUEUE_LIST: `${BASE_URL}/user/department/admin-view-queue-list`,
            CREATE_QUEUE: `${BASE_URL}/user/department/admin-create-queue`,
            UPDATE_QUEUE: `${BASE_URL}/user/department/admin-update-queue`,
            DELETE_QUEUE: `${BASE_URL}/user/department/admin-delete-queue`,
            ADMIN_USER_LIST: `${BASE_URL}/user/user-management/user-list`,
            GET_SKILLS: `${BASE_URL}/user/department/admin/skills`,
            SUPERVISOR_CHAT_HISTORY: `${getChatServiceUrl()}/supervisor/chat/history`,
            VIEW_CHAT_PDF: `${getChatServiceUrl()}/supervisor/export/chat-pdf`,
            VIEW_CHAT_PDF_REPORTING: `${getReportingServiceUrl()}/reporting/export/chat-pdf`,
            EXPORT_CHAT_HISTORY_CSV: `${getChatServiceUrl()}/supervisor/chat/history/download`,
            REGISTER_USER: `${BASE_URL}/user/user-management/user-register`,
            UPDATE_USER: `${BASE_URL}/user/user-management/user-update`,
            DELETE_USER: `${BASE_URL}/user/user-management/user-delete`,
            TICKET_LIST: `${BASE_URL}/user/ticket/list`,
            TECHSUPPORT_TICKET_LIST: `${BASE_URL}/user/tech-support/ticket/list`,
            CREATE_TICKET: `${BASE_URL}/user/ticket/create`,
            AGENT_LIST_BY_QUEUE: `${BASE_URL}/user/ticket/agent-list-by-queueId`,
            ASSIGN_TICKET: `${BASE_URL}/user/ticket/assignTicket`,
            TICKET_STATUS: `${BASE_URL}/user/ticket/status/list`,
            TICKET_HISTORY: `${BASE_URL}/user/ticket/ticketId`,
            UPDATE_TICKET_BY_AGENT: `${BASE_URL}/user/ticket/update-by-agent`,
            SUPERVISOR_CLOSE_TICKET: `${BASE_URL}/user/ticket/supervisor/close-ticket`,
            CREATE_CHILD_TICKET: `${BASE_URL}/user/ticket/create-child`,
            CHILD_TICKET_LIST: `${BASE_URL}/user/ticket/child-list`,
            ESCALATE_TICKET: `${BASE_URL}/user/ticket/escalate-to-supervisor`,


            // ===============================================================
            STATUS: `${WEB_SCRAPING_SERVICE_URL}/api/status`,
            AI_SUMMARY: `${WEB_SCRAPING_SERVICE_URL}/api/ai/summary`,
            AI_COSTS: `${WEB_SCRAPING_SERVICE_URL}/api/ai/costs`,
            AI_COSTS_BY_MODEL: `${WEB_SCRAPING_SERVICE_URL}/api/ai/costs/by-model`,
            AI_ACTIVE_JOBS: `${WEB_SCRAPING_SERVICE_URL}/api/ai/active-jobs`,
            AI_LOGS: `${WEB_SCRAPING_SERVICE_URL}/api/ai/logs`,
            AI_MODELS: `${WEB_SCRAPING_SERVICE_URL}/api/ai/models`,
            JOBS: `${WEB_SCRAPING_SERVICE_URL}/api/jobs`,
            JOBS_FILES: `${WEB_SCRAPING_SERVICE_URL}/api/jobs/files`,
            GET_TICKET_MEDIA: `${BASE_URL}/user/ticket/getMediaUrl`,
            WHATSAPP_BOT_TICKET_RAISE: "/ai/whatsapp-bot/ticket/raise",
            WHATSAPP_BOT_TICKET_REOPEN: "/ai/whatsapp-bot/ticket/reopen"
        };
    },
    get WS() {
        return {
            CONNECT: `${getChatServiceUrl()}/ws`,
        };
    },
    get SSE() {
        return {
            CONNECT: `${getChatServiceUrl()}/message/stream`,
        };
    }
};

export default ENDPOINTS;
